import styled from "styled-components";

const CheckBoxContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 1rem;
  padding: 1rem 0rem;
`;

const StyledCheckBox = styled.div`
  width: 14px;
  height: 14px;
  background: ${(props) => (props.checked ? "#0095FF" : "transparent")};
  border-radius: 4px;
  transition: all 150ms;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc; /* Add a border for better visibility */
`;

const CheckedIcon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;

const CalendarRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CalendarColumn = styled.div`
  flex: 0 0 48%; /* Adjust the width of each column */
`;

const CheckBoxLabel = styled.div`
  user-select: none;
`;

export {
  CheckBoxContainer,
  StyledCheckBox,
  CheckedIcon,
  CalendarRow,
  CalendarColumn,
  CheckBoxLabel,
};
